// extracted by mini-css-extract-plugin
export var bullet = "_oc-q";
export var bulletText = "_oc-p";
export var bullets = "_oc-k";
export var callout = "_oc-g";
export var calloutBody = "_oc-i";
export var calloutLabel = "_oc-h";
export var checkIcon = "_oc-m";
export var checkList = "_oc-j";
export var checkSvg = "_oc-n";
export var checkText = "_oc-o";
export var fieldCard = "_oc-1";
export var fieldDescription = "_oc-5";
export var fieldHeader = "_oc-3";
export var fieldTitle = "_oc-4";
export var finalNote = "_oc-s";
export var flow = "_oc-x";
export var flowArrow = "_oc-v";
export var flowStep = "_oc-u";
export var helperText = "_oc-r";
export var inlineTitle = "_oc-t";
export var listItem = "_oc-l";
export var noteBody = "_oc-8";
export var noteBodyText = "_oc-9";
export var noteCard = "_oc-2";
export var noteIcon = "_oc-6";
export var noteTitle = "_oc-7";
export var productChoices = "_oc-w";
export var radioDot = "_oc-d";
export var radioDotSelected = "_oc-e";
export var radioDotSvg = "_oc-f";
export var selectableCard = "_oc-b";
export var selectableCardSelected = "_oc-c";
export var strongText = "_oc-a";
export var subHeading = "_oc-0";